import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../Components/TableHelper";
import { useFormik } from "formik";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import Breadcrumb from "../../Components/Breadcrumb";
import Select from "react-select";
import { customStyles } from "../../utils/constant";


const AddPriceList = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const editingId = editData?._id;

  const [countryData, setCountryData] = useState([]);
  const [priceTypeData, setPriceTypeData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [qualityData, setQualityData] = useState([]);
  const [traceabilityData, setTraceabilityData] = useState([]);
  const [packSizeData, setPackSizeData] = useState([]);
  const [packBagData, setPackBagData] = useState([]);

  useEffect(() => {
    const apis = [
     { url: "category/getWithoutPaginationCategory", setter: setCategoryData },
      {
        url: "priceType/getWithoutPaginationPriceTypes",
        setter: setPriceTypeData,
      },
      { url: "packBag/getWithoutPaginationPackBags", setter: setPackBagData },
      { url: "country/getWithoutPaginationCountries", setter: setCountryData },
    ];
    apis.forEach(({ url, setter }) => {
      axiosInstance
        .get(url)
        .then((res) => setter(res.data?.data || []))
        .catch(() => setter([]));
    });
  }, []);

  const fetchByCategory = async (categoryId) => {
    if (!categoryId) {
      setQualityData([]);
      setTraceabilityData([]);
      setPackSizeData([]);
      return;
    }

    try {
      const response = await axiosInstance.get(
        `category/getCategoryWiseQualityTraceability/${categoryId}`,
      );
      const data = response.data.data;
      setTraceabilityData(data.traceabilityIds || []);
      setQualityData(data.qualityIds || []);
      setPackSizeData(data.packSizeIds || []);
    } catch (err) {
      setQualityData([]);
      setTraceabilityData([]);
    }
  };
  const fetchPackSizesByCategory = async (categoryId) => {
    if (!categoryId) {
      setPackSizeData([]);
      return;
    }
    try {
      const res = await axiosInstance.get(
        `packSize/getCategoryWisePackSizes/${categoryId}`
      );
      setPackSizeData(res.data?.data || []);
    } catch {
      setPackSizeData([]);
    }
  };

 


  const initialValues = {
    sortOrder: editData?.sortOrder || 1,
    country_id: editData?.country_id?._id || null,
    priceType_id: editData?.priceType_id?._id || null,
    category_id: editData?.category_id?._id || null,
    quality_id: editData?.quality_id?._id || null,
    traceability_id: editData?.traceability_id?._id || null,
    packSize_id: editData?.packSize_id?._id || null,
    packBag_id: editData?.packBag_id?._id || null,
    price: editData?.price || "",
    isActive: editData?.isActive ?? false,
  };

  const { values, errors, handleChange, handleSubmit, setFieldValue, touched } =
    useFormik({
      initialValues,
      // validationSchema: buildSchema(isProductBased),
      enableReinitialize: false,
      onSubmit: async (values) => {
        setLoading(true);
        try {
          const payload = {
            ...values,
            quality_id: values.quality_id,
            traceability_id:  values.traceability_id,
          };

          const response = editingId
            ? await axiosInstance.put(
                `/priceList/updatePriceList/${editingId}`,
                payload,
              )
            : await axiosInstance.post("/priceList/createPriceList", payload);

          if (response.status === 200) {
            toast.success(response.data.message);
            navigator("/price-list");
          }
        } catch (error) {
          toast.error(error.response?.data?.message || "Something went wrong.");
        } finally {
          setLoading(false);
        }
      },
    });

  const handleCategoryChange = (selected) => {
    const catId = selected?.value || "";
    setFieldValue("category_id", catId);

    setFieldValue("quality_id", "");
    setFieldValue("traceability_id", "");
    setFieldValue("packSize_id", ""); 

    if (catId) {
      fetchPackSizesByCategory(catId);
    } else {
       setQualityData([]);
      setTraceabilityData([]);
      setPackSizeData([]);
    }
  };

 

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Price List", path: "/price-list" },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];

  useEffect(() => {
    if (values.category_id) {
      fetchByCategory(values.category_id);
    } else {
      setQualityData([]);
      setTraceabilityData([]);
      setPackSizeData([]);
    }
  }, [values.category_id, categoryData]);
   const countryOptions = countryData.map((item) => ({
    label: item.countryName,
    value: item._id,
  }));
  const priceTypeOptions = priceTypeData.map((item) => ({
    label: item.priceTypeCode,
    value: item._id,
  }));
  const categoryOptions = categoryData.map((item) => ({
    label: item.categoryName,
    value: item._id,
  }));
  const qualityOptions = qualityData.map((item) => ({
    label: item.qualityName,
    value: item._id,
  }));
  const traceabilityOptions = traceabilityData.map((item) => ({
    label: item.traceabilityName,
    value: item._id,
  }));
  const packSizeOptions = packSizeData.map((item) => ({
    label: item.packSizeName,
    value: item._id,
  }));
  const packBagOptions = packBagData.map((item) => ({
    label: item.packBagName,
    value: item._id,
  }));

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mb-3">
          <h3 className="custom-page-title">
            {editingId ? "Update" : "Add"} Price List
          </h3>

          <h4>All prices are in US Dollars</h4>
          <Breadcrumb items={breadcrumbdata} />
        </div>

        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card m-0">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row g-4">

                  {/* Sort Order */}
                  <div className="col-sm-4 mb-3">
                    <div className="form-group">
                      <label htmlFor="priceList-sortOrder" className="col-form-label">
                        Sort Order
                      </label>
                      <input
                        type="number"
                        className="form-control border-dark"
                        id="priceList-sortOrder"
                        name="sortOrder"
                        placeholder="Enter Sort Order"
                        min={1}
                        value={values.sortOrder}
                        onChange={handleChange}
                      />
                      {touched.sortOrder && errors.sortOrder && (
                        <small className="text-danger">{errors.sortOrder}</small>
                      )}
                    </div>
                  </div>

                  {/* Price */}
                  <div className="col-sm-4 mb-3">
                    <div className="form-group">
                      <label htmlFor="priceList-Price" className="col-form-label">
                        Price
                      </label>
                      <input
                        type="number"
                        step="0.01"
                        min="0"
                        className="form-control border-dark"
                        id="priceList-Price"
                        name="price"
                        placeholder="Enter Price"
                        value={values.price}
                        onChange={handleChange}
                      />
                      {touched.price && errors.price && (
                        <small className="text-danger">{errors.price}</small>
                      )}
                    </div>
                  </div>

                  {/* Country */}
                  <div className="col-sm-4 mt-2">
                    <label>Country</label>
                    <Select
                      options={countryOptions}
                      value={countryOptions.find((opt) => opt.value === values.country_id) || null}
                      isClearable
                      styles={customStyles}
                      onChange={(selected) => setFieldValue("country_id", selected?.value || "")}
                      placeholder="Select Country"
                    />
                    {touched.country_id && errors.country_id && (
                      <small className="text-danger">{errors.country_id}</small>
                    )}
                  </div>

                  {/* Price Type */}
                  <div className="col-sm-4 mb-3">
                    <label>Price Type</label>
                    <Select
                      options={priceTypeOptions}
                      value={priceTypeOptions.find((opt) => opt.value === values.priceType_id) || null}
                      isClearable
                      styles={customStyles}
                      onChange={(selected) => setFieldValue("priceType_id", selected?.value || "")}
                      placeholder="Select Price Type"
                    />
                    {touched.priceType_id && errors.priceType_id && (
                      <small className="text-danger">{errors.priceType_id}</small>
                    )}
                  </div>

                  {/* Category */}
                  <div className="col-sm-4 mb-3">
                    <label>Category</label>
                    <Select
                      options={categoryOptions}
                      value={categoryOptions.find((opt) => opt.value === values.category_id) || null}
                      isClearable
                      styles={customStyles}
                      onChange={handleCategoryChange}
                      placeholder="Select Category"
                    />
                    {touched.category_id && errors.category_id && (
                      <small className="text-danger">{errors.category_id}</small>
                    )}
                  </div>

              
                  
                    {
                      qualityOptions && qualityOptions.length > 0 && (
                      <div className="col-sm-4 mb-3">
                        <label>Quality</label>
                        <Select
                          options={qualityOptions}
                          value={qualityOptions.find((opt) => opt.value === values.quality_id) || null}
                          isClearable
                          styles={customStyles}
                          onChange={(selected) => setFieldValue("quality_id", selected?.value || "")}
                          placeholder="Select Quality"
                        />
                        {touched.quality_id && errors.quality_id && (
                          <small className="text-danger">{errors.quality_id}</small>
                        )}
                      </div>

                      )
                    }


                    {
                      traceabilityOptions && traceabilityOptions.length > 0 && (
                      <div className="col-sm-4 mb-3">
                        <label>Source</label>
                        <Select
                          options={traceabilityOptions}
                          value={traceabilityOptions.find((opt) => opt.value === values.traceability_id) || null}
                          isClearable
                          styles={customStyles}
                          onChange={(selected) => setFieldValue("traceability_id", selected?.value || "")}
                          placeholder="Select Source"
                        />
                        {touched.traceability_id && errors.traceability_id && (
                          <small className="text-danger">{errors.traceability_id}</small>
                        )}
                      </div>
                      )
                    }

                   

                 {
                  packSizeOptions && packSizeOptions.length > 0 && (
                  <div className="col-sm-4 mb-3">
                    <label>Pack Size</label>
                    <Select
                      options={packSizeOptions}
                      value={packSizeOptions.find((opt) => opt.value === values.packSize_id) || null}
                      isClearable
                      styles={customStyles}
                      onChange={(selected) => setFieldValue("packSize_id", selected?.value || "")}
                      placeholder={
                        values.category_id
                          ? "Select Pack Size"
                          : "Select a category first" 
                      }
                      isDisabled={!values.category_id} 
                    />
                    {touched.packSize_id && errors.packSize_id && (
                      <small className="text-danger">{errors.packSize_id}</small>
                    )}
                  </div>
                  )
                 }

                {
                  packBagOptions && packBagOptions.length > 0 && (
                  <div className="col-sm-4 mb-3">
                    <label>Pack Bag</label>
                    <Select
                      options={packBagOptions}
                      value={packBagOptions.find((opt) => opt.value === values.packBag_id) || null}
                      isClearable
                      styles={customStyles}
                      onChange={(selected) => setFieldValue("packBag_id", selected?.value || "")}
                      placeholder="Select Pack Bag"
                    />
                    {touched.packBag_id && errors.packBag_id && (
                      <small className="text-danger">{errors.packBag_id}</small>
                    )}
                  </div>
                  )
                }

                  {/* Is Active */}
                  <div className="col-md-12 mt-4">
                    <SwitchToggle
                      checked={values.isActive}
                      onChange={(val) => setFieldValue("isActive", val)}
                    />
                  </div>

                </div>

                <div className="text-center mt-4">
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? (
                      <span className="d-inline-flex align-items-center gap-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        />
                        Processing...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>
                  <Link to="/price-list">
                    <Button color="danger mx-2">Cancel</Button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPriceList;